export const getUnitOfMeasure = (code:string) =>{
     switch(code){
        case '1':return 'Miles'
        case '2':return 'Kilometers'
        case '3':return 'Meters'
        case '4':return 'Millimeters'
        case '5':return 'Centimeters'
        case '6':return 'Yards'
        case '7':return 'Feet'
        case '8':return 'Inches'
        case '9':return 'Pixels'
        case '10':return 'Block'
        case '11':return 'Megabytes'
        case '12':return 'Gigabytes'
        case '13':return 'Square feet'
        case '14':return 'Square meters'
        case '15':return 'Pounds'
        case '16':return 'Kilograms'
        case '17':return 'Square inch'
        case '18':return 'Square yard'
        case '19':return 'Acre'
        case '20':return 'Square millimeter'
        case '21':return 'Square centimeter'
        case '22':return 'Hectare'
        case '23':return 'Ounce'
        case '24':return 'Gram'
        case '25':return 'Gallons'
        case '26':return 'Liters'
        case '27':return 'Kilowatts'
        case '28':return 'Cubic meters'
        default: return ''
    }
}

